export class Topic {
    syllabuscode:string=""
    id=0
    server_topic_id=0
    name:""
    description:""
    datecreated:Date
    lastupdated:Date
    subtopics=[]
    server_syllabus_id:0
    questionsPassedCount:0
    questionsAttemptedCount:0
    percentagePass:0

}
